import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { HiScale, HiClipboardDocumentList, HiExclamationTriangle } from 'react-icons/hi2';

const TabGroup = ({ children }) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('rights');

  const tabs = [
    { id: 'rights', label: t('tabs.rights'), icon: HiScale },
    { id: 'procedures', label: t('tabs.procedures'), icon: HiClipboardDocumentList },
    { id: 'problems', label: t('tabs.problems'), icon: HiExclamationTriangle }
  ];

  return (
    <div className="space-y-6">
      {/* Tab Navigation */}
      <div className="border-b border-gray-200 dark:border-gray-700">
        <nav className="flex flex-nowrap -mb-px gap-1" aria-label="Tabs">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`
                  group inline-flex items-center gap-2.5 px-3 md:px-4 py-3 border-b-2 font-medium text-sm transition-colors whitespace-nowrap
                  ${isActive
                    ? 'border-teal-600 dark:border-teal-400 text-teal-600 dark:text-teal-400'
                    : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600'
                  }
                `}
              >
                <Icon className={`h-5 w-5 flex-shrink-0 ${isActive ? 'text-teal-600 dark:text-teal-400' : 'text-gray-400 dark:text-gray-500'}`} />
                <span className="whitespace-nowrap">{tab.label}</span>
              </button>
            );
          })}
        </nav>
      </div>

      {/* Tab Content */}
      <div className="mt-6">
        {React.Children.map(children, (child) => {
          if (React.isValidElement(child) && child.props.tabId === activeTab) {
            return child;
          }
          return null;
        })}
      </div>
    </div>
  );
};

export const TabPanel = ({ tabId, children }) => {
  return <div className="space-y-6">{children}</div>;
};

export default TabGroup;
